import axios from "axios";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { buildDxFilters, GetFormatedDateWithTime } from '../../common/Utils'
import DataSource from "devextreme/data/data_source";

export const GetItemMasterMainGridData = (accessToken, url, formFields) => {
  const resultData = createStore({
    key: 'rowid',
    loadParams: {
      Rowid: () => formFields.Rowid,
      WarehouseID: () => formFields.WarehouseID,
      ItemCode: () => formFields.ItemCode,
      Description_1: () => formFields.Description_1,
      Description_2: () => formFields.Description_2,
      ClassCode: () => formFields.ClassCode,
      SubClassCode: () => formFields.SubClassCode,
      Available: () => formFields.Available,
      DateAvailable: () => GetFormatedDateWithTime(formFields.DateAvailable),
      AverageCost: () => formFields.AverageCost,
      BomExplosionFlag: () => formFields.BomExplosionFlag,
      UserDefinedCode1: () => formFields.UserDefinedCode1,
      UserDefinedCode2: () => formFields.UserDefinedCode2,
      UserDefinedCode3: () => formFields.UserDefinedCode3,
      UserDefinedCode4: () => formFields.UserDefinedCode4,
      UserDefinedCode5: () => formFields.UserDefinedCode5,
      UserDefinedCode6: () => formFields.UserDefinedCode6,
      UserDefinedCode7: () => formFields.UserDefinedCode7,
      UserDefinedCode8: () => formFields.UserDefinedCode8,
      UserDefinedCode9: () => formFields.UserDefinedCode9,
      UserDefinedCode10: () => formFields.UserDefinedCode10,
      CreationUserId: () => formFields.CreationUserId,
      CreationDateTime: () => GetFormatedDateWithTime(formFields.CreationDateTime),
      LastUpdateDateTime: () => GetFormatedDateWithTime(formFields.LastUpdateDateTime),
      UserDefinedDate1: () => GetFormatedDateWithTime(formFields.UserDefinedDate1),
      UserDefinedDate2: () => GetFormatedDateWithTime(formFields.UserDefinedDate2),
      UserDefinedDate3: () => GetFormatedDateWithTime(formFields.UserDefinedDate3),
      UserDefinedDate4: () => GetFormatedDateWithTime(formFields.UserDefinedDate4),
      UserDefinedDate5: () => GetFormatedDateWithTime(formFields.UserDefinedDate5),
      UserDefinedDate6: () => GetFormatedDateWithTime(formFields.UserDefinedDate6),
      UserDefinedDate7: () => GetFormatedDateWithTime(formFields.UserDefinedDate7),
      UserDefinedDate8: () => GetFormatedDateWithTime(formFields.UserDefinedDate8),
      UserDefinedDate9: () => GetFormatedDateWithTime(formFields.UserDefinedDate9),
      UserDefinedDate10: () => GetFormatedDateWithTime(formFields.UserDefinedDate10),
      DateExpiration: () => formFields.DateExpiration,
      InReceiving: () => formFields.InReceiving,
      CareInstructions: () => formFields.CareInstructions,
      DateIntroduced: () => formFields.DateIntroduced,
      InventoryUnitUom: () => formFields.InventoryUnitUom,
      ItemSourceFlag: () => formFields.ItemSourceFlag,
      ItemType: () => formFields.ItemType,
      LastCost: () => formFields.LastCost,
      LastUpdateUserId: () => formFields.LastUpdateUserId,
      PriceLevelA: () => formFields.PriceLevelA,
      PriceLevelB: () => formFields.PriceLevelB,
      PriceLevelC: () => formFields.PriceLevelC,
      PriceLevelD: () => formFields.PriceLevelD,
      PriceLevelE: () => formFields.PriceLevelE,
      Status: () => formFields.Status,
      UserDefinedQuantity1: () => formFields.UserDefinedQuantity1,
      UserDefinedQuantity2: () => formFields.UserDefinedQuantity2,
      UserDefinedQuantity3: () => formFields.UserDefinedQuantity3,
      UserDefinedQuantity4: () => formFields.UserDefinedQuantity4,
      UserDefinedQuantity5: () => formFields.UserDefinedQuantity5,
      UserDefinedQuantity6: () => formFields.UserDefinedQuantity6,
      UserDefinedQuantity7: () => formFields.UserDefinedQuantity7,
      UserDefinedQuantity8: () => formFields.UserDefinedQuantity8,
      UserDefinedQuantity9: () => formFields.UserDefinedQuantity9,
      UserDefinedQuantity10: () => formFields.UserDefinedQuantity10,
      UserDefinedReference1: () => formFields.UserDefinedReference1,
      UserDefinedReference2: () => formFields.UserDefinedReference2,
      UserDefinedReference3: () => formFields.UserDefinedReference3,
      UserDefinedReference4: () => formFields.UserDefinedReference4,
      UserDefinedReference5: () => formFields.UserDefinedReference5,
      UserDefinedReference6: () => formFields.UserDefinedReference6,
      UserDefinedReference7: () => formFields.UserDefinedReference7,
      UserDefinedReference8: () => formFields.UserDefinedReference8,
      UserDefinedReference9: () => formFields.UserDefinedReference9,
      UserDefinedReference10: () => formFields.UserDefinedReference10,
      DateExpiration:()=>formFields.DateExpiration,
      CareInstructions:()=>formFields.CareInstructions,
      DateIntroduced:()=>formFields.DateIntroduced,
      InventoryUnitUom:()=>formFields.InventoryUnitUom,
      OnHand:()=>formFields.OnHand,
      WearHouseName:()=>formFields.WearHouseName,
      Locationmaxunitsforwardpick :()=>formFields.Locationmaxunitsforwardpick,
      Locationmaxunitsreplenishment:()=>formFields.Locationmaxunitsreplenishment,
      Minimumsalesquantity :()=>formFields.Minimumsalesquantity,
      Locationminunitsforwardpick:()=>formFields.Locationminunitsforwardpick,
      Locationminunitsreplenishment:()=>formFields.Locationminunitsreplenishment,
      WarehouseID:()=>formFields.WarehouseID,
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`
      };
    }
  });
  return resultData;
};
export const GetItemLotGridData = (accessToken, url, formFields) => {
  const resultData = createStore({
    key: 'rowid',
    loadParams:
    {
      Warehouse: function () {
        return formFields.Warehouse;
      },
      Lotcode: function () {
        return formFields.Lotcode;
      },
      LotDescription: function () {
        return formFields.LotDescription;
      },
      LotClasscode: function () {
        return formFields.LotClasscode;
      },
      LotSubclasscode: function () {
        return formFields.LotSubclasscode;
      },
      LotOversellpercentage: function () {
        return formFields.LotOversellpercentage;
      },
      Itemcode: function () {
        return formFields.Itemcode;
      },
      ItemDescription: function () {
        return formFields.ItemDescription;
      },
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    },
  });
  return resultData;
};
export const GetSalesOrderGridData = (accessToken, url, formFields, OrderStatus,layout) => {
  const filters = buildDxFilters(formFields,layout);
  const resultData = createStore({
    key: 'rowid',
    loadParams:
 
    {
      ShippingDateFrom: function () {
        return GetFormatedDateWithTime(formFields.ShippingDateFrom);
      },
      ShippingDateTo: function () {
        return GetFormatedDateWithTime(formFields.ShippingDateTo);
      },
      OrderDateFrom: function () {
        return GetFormatedDateWithTime(formFields.OrderDateFrom);
      },
      OrderDateTo: function () {
        return GetFormatedDateWithTime(formFields.OrderDateTo);
      },
      ProfileId: function () {
        return formFields.R_PROFILE;
      },
      CustomerId: function () {
        return formFields.R_CUSTOMER;
      },
      TransactionNumber: function () {
        return formFields.TRANSACTIONNUMBER;
      },
      PurchseOrderNumber: function () {
        return formFields.PURCHASEORDERNUMBER;
      },
      OrderStatus: function () {
        return OrderStatus;
      },
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    },
  });
   const dataSource = new DataSource({ store: resultData });
 dataSource.filter(filters);

  return dataSource;
};
export const GetOrderDetailGridData = (accessToken, url, headerId) => {
  const resultData = createStore({
    key: 'rowid',
    loadParams:
    {
      headerId: function () {
        return headerId;
      },
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    },
  });
  return resultData;
};
export const GetCustomerOrders = (accessToken, url, cutomerId,orderStatus) => {
  const resultData = createStore({
    key: 'rowid',
    loadParams:
    {
      cutomerId: function () {
        return cutomerId;
      },
      orderStatus: function () {
        return orderStatus;
      },
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    },
  });
  return resultData;
};
export const GetArOpenItemGridData = (accessToken, url, customerId) => {
  const resultData = createStore({
    key: 'rowid',
    loadParams:
    {
      customerId: function () {
        return customerId;
      },
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    },
  });
  return resultData;
};
export const GetItemMasterGridData = (accessToken, url) => {
  const resultData = createStore({
    key: 'rowid',
    loadParams:
    {
      itemId: function () {
        return '';
      },
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    },
  });
  return resultData;
};
export const GetCustomerGridGridData = (accessToken, url,formFields) => {
  const resultData = createStore({
    key: 'rowid',
    loadParams:
    {
      CustomerId: function () {
        return formFields?.R_CUSTOMER;
      },
      Name: function () {
        return formFields?.Name;
      },
      Address1: function () {
        return formFields?.Address1;
      },
      Address2: function () {
        return formFields?.Address2;
      },
      City: function () {
        return formFields?.City;
      },
      State: function () {
        return formFields?.State;
      },
      Zip: function () {
        return formFields?.Zip;
      },
      Tel: function () {
        return formFields?.Tel;
      },
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    },
  });
  return resultData;
};
export const GetLookupData = async (name, url, accessToken, formRefs, setForceRender, forceRender) => {
  try {
    const response = await axios.get(`${window._env_.REACT_APP_APIS}/${url}`, {
      headers: {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`
      }
    });
    const responseData = response.data;
    if (responseData.success) {
      const newOptions = responseData.lookups.map(item => ({
        id: item.rowid,
        name: item.code
      }));
      if (formRefs.current[name]) {
        
        formRefs.current[name].instance().option('dataSource', newOptions);
        formRefs.current[name].instance().option('valueExpr', 'id');
        formRefs.current[name].instance().option('displayExpr', 'name');
        setForceRender(!forceRender);
      }
      console.log(newOptions);
      return newOptions;
    }
    else {
      return null;
    }
  }
  catch (error) {
    return null;

    } 
};

// Injects static {ID,Text} options onto a dynamic-form SelectBox ref. `currentValue` (optional) re-applies
// the bound value after the options arrive, so an edit form's pre-set value still resolves/displays;
// `setForceRender` is optional so callers that re-render another way (e.g. via bound formFields) can omit it.
export const GetLookupStaticData = async (name,responseData,formRefs,setForceRender,forceRender,currentValue) => {
  try {

      if (responseData) {
          const newOptions = responseData.map(item => ({
              id: item.ID,
              name: item.Text
          }));
          if (formRefs.current[name]) {
              formRefs.current[name].instance().option('dataSource', newOptions);
              formRefs.current[name].instance().option('valueExpr', 'id');
              formRefs.current[name].instance().option('displayExpr', 'name');
              if (currentValue !== undefined) formRefs.current[name].instance().option('value', currentValue);
              if (setForceRender) setForceRender(!forceRender);
          }
          return newOptions;
      }
      else 
      {
          return null;
      }
  } 
  catch (error) 
  {
      return null;

  } 
  }